import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schemas from './profile.schema';

const fetchProfile = (id) => ({
	[CALL_SORTED_API]: {
		types: ['PROFILE_REQUEST', 'PROFILE_SUCCESS', 'PROFILE_FAILURE'],
		endpoint: `profiles/${id}`,
		schema: Schemas.PROFILE,
		mapActionToStateKey: 'profile'
	}
});

export const loadProfile = (id) => (dispatch) => dispatch(fetchProfile(id));

const UPDATE_PROFILE = ['UPDATE_PROFILE_REQUEST', 'UPDATE_PROFILE_SUCCESS', 'UPDATE_PROFILE_FAILURE'];

const putProfile = (id, body) => ({
	[CALL_SORTED_API]: {
		types: UPDATE_PROFILE,
		endpoint: `profiles/${id}/attributes`,
		body,
		method: 'PUT',
		schema: Schemas.PROFILE,
		mapActionToStateKey: 'profile'
	}
});

export const updateProfile = (id, body) => (dispatch) => dispatch(putProfile(id, body));

const DELETE_PROFILE_ATTRIBUTE = ['DELETE_ATTRIBUTE_REQUEST', 'DELETE_ATTRIBUTE_SUCCESS', 'DELETE_ATTRIBUTE_FAILURE'];

const deleteProfileAttribute = (profileId, attributeId) => ({
	[CALL_SORTED_API]: {
		types: DELETE_PROFILE_ATTRIBUTE,
		endpoint: `profiles/${profileId}/attribute/${attributeId}`,
		method: 'PUT',
		schema: Schemas.PROFILE,
		mapActionToStateKey: 'profile'
	}
});

export const deleteAttribute = 	(profileId, attributeId) => (dispatch) => dispatch(deleteProfileAttribute(profileId, attributeId));

const RESEND_PROFILE_EMAIL_CONFIRMATION = ['RESEND_EMAIL_REQUEST', 'RESEND_EMAIL_SUCCESS', 'RESEND_EMAIL_FAILURE'];

const resendEmail = (profileId, attributeId) => ({
	[CALL_SORTED_API]: {
		types: RESEND_PROFILE_EMAIL_CONFIRMATION,
		endpoint: `profiles/${profileId}/attribute/${attributeId}/resend`,
		method: 'PUT',
		schema: Schemas.PROFILE,
		mapActionToStateKey: 'profile'
	}
});

export const resendConfirmationEmail = (profileId, attributeId) => (dispatch) => dispatch(resendEmail(profileId, attributeId));

export const ProfileActionTypes = {
	UPDATE_PROFILE,
	DELETE_PROFILE_ATTRIBUTE,
	RESEND_PROFILE_EMAIL_CONFIRMATION
};
